import React from "react";

const styles = {
  root: {
    height: 12,
    width: 12,
    cursor: "pointer",
    border: 0,
    background: "none",
    padding: 0,
  },
  dot: {
    backgroundColor: "#e4e6e7",
    height: 8,
    width: 8,
    borderRadius: 4,
    margin: 2,
  },
  active: {
    backgroundColor: "#666666",
  },
};

class PaginationDot extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick(event) {
    this.props.onClick(event, this.props.index);
  }

  render() {
    const { active } = this.props;

    let styleDot;

    if (active) {
      styleDot = Object.assign({}, styles.dot, styles.active);
    } else {
      styleDot = styles.dot;
    }

    return (
      <button type="button" style={styles.root} onClick={this.handleClick}>
        <div style={styleDot} />
      </button>
    );
  }
}

export default PaginationDot;
